import React from 'react';

const StatCard = ({ value, label, description }) => {
  return (
    <article className="stat-card">
      <p className="stat-value">{value}</p>
      <p className="stat-label">{label}</p>
      {description && <p className="stat-description">{description}</p>}
    </article>
  );
};

export default StatCard;
